<script setup lang="ts">
import { useAdminStore } from '../stores/admin';

const store = useAdminStore();

function openRefundTasks() {
  store.targetOrderTab = 'REFUND';
  store.selectMenu('发货退款');
}

function openShippingTasks() {
  store.targetOrderTab = 'PENDING';
  store.selectMenu('发货退款');
}

function openPickupTasks() {
  store.targetOrderTab = 'PICKUP';
  store.selectMenu('发货退款');
}
</script>

<template>
  <div class="overview-container">
    <div class="panel overview-panel">
      <div class="panel-heading">
        <div>
          <p class="eyebrow">待处理事项</p>
          <h2>今天需要关注的任务</h2>
        </div>
        <el-tag type="danger" effect="dark" round v-if="store.pendingShipments + store.pendingRefunds > 0">
          {{ store.pendingShipments + store.pendingRefunds }} 项需处理
        </el-tag>
        <el-tag type="info" effect="plain" round v-else>暂无待办</el-tag>
      </div>

      <div class="overview-list">
        <div class="overview-card" @click="openRefundTasks">
          <div class="card-icon quote-icon">退</div>
          <div class="card-body">
            <div class="card-title">退款中订单</div>
            <div class="card-desc">
              {{ store.pendingRefunds ? `${store.pendingRefunds} 单退款待审核或处理中` : '暂无待处理退款' }}
            </div>
          </div>
          <el-button type="primary" link icon="ArrowRight">去处理</el-button>
        </div>

        <div class="overview-card" @click="openShippingTasks">
          <div class="card-icon ship-icon">运</div>
          <div class="card-body">
            <div class="card-title">待发货/待备货订单</div>
            <div class="card-desc">
              {{ store.pendingShipments ? `${store.pendingShipments} 单需要安排发货或打包` : '暂无待发货订单' }}
            </div>
          </div>
          <el-button type="primary" link icon="ArrowRight">去处理</el-button>
        </div>

        <div class="overview-card" @click="openPickupTasks">
          <div class="card-icon pickup-icon">核</div>
          <div class="card-body">
            <div class="card-title">待到店核销自提</div>
            <div class="card-desc">
              {{ store.pickupReady ? `${store.pickupReady} 单顾客即将到店扫码自提` : '暂无待核销自提单' }}
            </div>
          </div>
          <el-button type="primary" link icon="ArrowRight">查看</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.overview-container {
  display: grid;
  gap: 20px;
}
.overview-list {
  display: grid;
  gap: 12px;
}
.overview-card {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px 20px;
  background: #fbfcfe;
  border: 1px solid #e5edf2;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.overview-card:hover {
  background: #ffffff;
  border-color: #409eff;
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.1);
  transform: translateY(-1px);
}
.card-icon {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  font-weight: bold;
  font-size: 16px;
}
.quote-icon { background: #fef0f0; color: #f56c6c; }
.ship-icon { background: #ecf5ff; color: #409eff; }
.pickup-icon { background: #f0f9eb; color: #67c23a; }
.card-body {
  flex: 1;
}
.card-title {
  font-size: 15px;
  font-weight: 600;
  color: #1f2d3d;
}
.card-desc {
  font-size: 13px;
  color: #8492a6;
  margin-top: 4px;
}
</style>
